import React from 'react';
import IndexTableView from './IndexTableView';

export default function StratIndexBase(props) {
  return (
    <IndexTableView
      header="Влияние стратегического проекта на достижение показателей эффективности УрФУ (базовая часть гранта)"
      typeFunding="base"
      strategyId={props.strategyId}
    />
  );
}
